!function () {
	"use strict";

	const t = "product-modal",
		i = "[data-popup-close]",
		o = "[data-notification-form]",
		e = "[data-product-notification-heading]",
		s = "has-success",
		n = "hidden";

	if (!customElements.get("product-notification")) {
		customElements.define("product-notification", class extends HTMLElement {

			constructor() {
				super();
				this.notificationForm = this.querySelector(o);
				this.preventSubmit = true;
				this.popup = this.closest("dialog");
				this.popupClose = this.popup?.querySelector(i);
			}

			connectedCallback() {
				this.checkState();

				if (this.notificationForm) {
					this.notificationForm.addEventListener("submit", (t) => this.notificationSubmitEvent(t));
				} else {
					console.warn('[⚠️ product-notification] Форма не знайдена');
				}

				if (this.popupClose) {
					this.popupClose.addEventListener("click", () => {
						this.removeStorage();
					});
				} else {
					console.warn('[⚠️ product-notification] Кнопка закриття не знайдена');
				}
			}

			checkState() {
				if (-1 !== window.location.search.indexOf("?contact_posted=true")) {
					this.querySelector(e)?.classList.add(n);
					this.closest(t)?.classList.add(s);
					if (this.popup) {
						this.popup.removeAttribute("inert");
						if ("function" == typeof this.popup.showModal) {
							this.popup.showModal();
						} else {
							this.popup.setAttribute("open", "");
						}
					}
				}
			}

			notificationSubmitEvent(t) {
				if (this.preventSubmit) {
					t.preventDefault();
					this.removeStorage();
					this.writeStorage();
					this.preventSubmit = false;
					this.notificationForm.submit();
				}
			}

			writeStorage() {
				if (window.sessionStorage !== undefined) {
					window.sessionStorage.setItem("notification_form_id", this.notificationForm.id);
				}
			}

			removeStorage() {
				window.sessionStorage.removeItem("notification_form_id");
			}

		});
	}

}();
